export class Franchise {
  FRANCHISE_ID: string;
  FRANCHISE_NAME: string;
  FRANCHISE_SCORE: number;
  BASE_MULTIPLE: number;

  // Helpers
  isOver: boolean;

  static parse(json: any): Franchise {
    if (json) {
      const f = new Franchise();

      f.FRANCHISE_ID = json.FRANCHISE_ID;
      f.FRANCHISE_NAME = json.FRANCHISE_NAME;
      f.FRANCHISE_SCORE = json.FRANCHISE_SCORE;
      f.BASE_MULTIPLE = json.BASE_MULTIPLE;

      return f;
    } else { return null; }
  }

  static parseArray(json: Array<any>): Array<Franchise> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Franchise.parse(j));

    return arr;
  }


}
